
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AslibAuthGuard } from '@aslib/security';
import { DistribuicaoMensalMunicipioComponent } from './consulta/distribuicao-mensal-aos-municipio/distribuicao-mensal-municipio.component';
import { PaginaInicialComponent } from './pagina-inicial/pagina-inicial.component';
import { IndiceParticipacaoMunicipioComponent } from './consulta/indice-participacao-municipio/indice-participacao-municipio.component';
import { SaldoDevedorMunicipioComponent } from './consulta/saldo-devedor-municipio/saldo-devedor-municipio.component';
import { ImportarPlanilhaIpmComponent } from './ipm/importacao-planilha-ipm/importar-planilha-ipm.component';
import { GerarArquivoIpmComponent } from './ipm/geracao-arquivo-ipm/geracao-arquivo-ipm.component';
import { TransmitirArquivoIpmComponent } from './ipm/transmissao-arquivo-ipm/transmissao-arquivo-ipm.component';
import { ConsultaIpvaComponent } from './ipva/consulta-ipva/consulta-ipva.component';
import { CadastroMunicipiosAptos } from './royalts/cadastra-municipios-aptos/cadastra-municipios-aptos.component';
import { CadastraValorMensalDistribuir } from './royalts/valor-mensal-distribuir/cadastra-valor-mensal-distribuir.component';
import { ConsultaMunicipiosAptos } from './royalts/cadastra-municipios-aptos/consulta-municipios-aptos.component';
import { GerarValorMensalDistribuir } from './royalts/cadastra-valor-mensal/gerar-valor-mensal/gerar-valor-mensal-municipio.component';
import { ConsultaValorMensalMunicipio } from './royalts/cadastra-valor-mensal/consulta-valor-mensal/consulta-valor-mensal-municipio.component';
import { ConsultaValorMensalDistribuir } from './royalts/valor-mensal-distribuir/consulta-valor-mensal-distribuir.component';
import { AprovacaoValorMensalComponent } from './royalts/aprovacao-valor-municipio/aprovacao-valor-mensal.component';

const tpIconEdit = 'fa fa-edit';

const routes: Routes = [
  {
    path: '',
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: PaginaInicialComponent,
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    data: {
      aslib: {
        menu: {
          aslibIcon: { type: 1, icon: 'fa fa-home' },
          text: 'Página Inicial'
        }
      }
      //,ascas: { title: 'Página Inicial' }
    }
  },


//iten do menu Cadastro

{
  path: 'consulta',
  canLoad: [AslibAuthGuard],
  canActivate: [AslibAuthGuard],
  data: {
    aslib: {
      menu: { aslibIcon: { type: 1, icon: tpIconEdit }, text: 'Consulta' }
    }
    ,  ascas: { title: 'Consulta' }
  },
  children: [
    {
      path: 'distribuicao-mensal-municipio',
      canLoad: [AslibAuthGuard],
      canActivate: [AslibAuthGuard],
      component: DistribuicaoMensalMunicipioComponent,
      data: {
        aslib: {
          menu: { hide: false, text: 'Distribuição mensal aos Municípios' }
        }
        ,ascas: { title: 'Distribuição mensal aos Municípios' }
      }
    },
    {
      path: 'indice-participacao-municipio',
      canLoad: [AslibAuthGuard],
      canActivate: [AslibAuthGuard],
      component: IndiceParticipacaoMunicipioComponent,
      data: {
        aslib: {
          menu: { hide: false, text: 'Índice de Participação do Município' }
        }
        ,ascas: { title: 'Índice de Participação do Município' }
      }
    }
    ,{
     path: 'saldo-devedor-municipio',
      canLoad: [AslibAuthGuard],
      canActivate: [AslibAuthGuard],
      component: SaldoDevedorMunicipioComponent,
      data: {
        aslib: {
          menu: { hide: false, text: 'Saldo Devedor Município' }
        }
        ,ascas: { title: 'Saldo Devedor Município' }
      }
    }
  ]
},



//iten do menu IPM

  {
    path: 'ipm',
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    data: {
      aslib: {
        menu: { aslibIcon: { type: 1, icon: tpIconEdit }, text: 'IPM' }
      }
      ,ascas: { title: 'IPM' }
    },
    children: [
      {
        path: 'importacao-planilha-ipm',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: ImportarPlanilhaIpmComponent,
        data: {
          aslib: { menu: { hide: false, text: 'Importação da planilha IPM' }},
          ascas: { title: 'Importação da planilha IPM' }
        }
      },
      {
        path: 'gerar-arquivo-ipm',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: GerarArquivoIpmComponent,
        data:{
          aslib: { menu: { hide: false, text: 'Geração de Arquivo IPM' }},
          ascas: { title: 'Geração de Arquivo IPM' }
        }
      },
      {
        path: 'transmissao-arquivo-ipm',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: TransmitirArquivoIpmComponent,
        data:{
          aslib: { menu: { hide: false, text: 'Transmissão de arquivo IPM' }},
          ascas: { title: 'Transmissão de arquivo IPM' }
        }
      }

    ]
  },


  //ipva
  {
    path: 'ipva',
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    data: {
      aslib: {
        menu: { aslibIcon: { type: 1, icon: tpIconEdit }, text: 'IPVA' }
      }
      ,ascas: { title: 'IPVA' }
    },
    children: [
      {
        path: 'sarf-consulta-ipva',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: ConsultaIpvaComponent,
        data: {
          aslib: { menu: { hide: false, text: 'Consolidação Municípios - SIGAT' }},
          ascas: { title: 'Consolidação Municípios - SIGAT' }
        }
      },
    ]
  },

   //Royalts
  {
    path: 'royalts',
    canLoad: [AslibAuthGuard],
    canActivate: [AslibAuthGuard],
    data: {
      aslib: {
        menu: { aslibIcon: { type: 1, icon: tpIconEdit }, text: 'Royalties' }
      }
      ,ascas: { title: 'Royalties' }
    },
    children: [

      {
        path: 'sarf-cadastra-valor-mensal-distribuir',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: CadastraValorMensalDistribuir,
        data: {
          aslib: { menu: { hide: true, text: ' Cadastrar Valor Mensal a Distribuir' }},
          ascas: { title: 'Cadastrar Valor Mensal a Distribuir' }
        }
      },
      {
        path: 'sarf-consulta-valor-mensal-distribuir',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: ConsultaValorMensalDistribuir,
        data: {
          aslib: { menu: { hide: false, text: ' Valor dos Royalties a Distribuir' }},
          ascas: { title: 'Valor dos Royalties a Distribuir' }
        }
      },
      {
        path: 'sarf-cadastro-municipios-aptos',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: CadastroMunicipiosAptos,
        data: {
          aslib: { menu: { hide: true, text: 'Cadastro de Municípios Aptos' }},
          ascas: { title: 'Cadastro de Municípios Aptos' }
        }
      },
      {
        path: 'sarf-consulta-municipios-aptos',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: ConsultaMunicipiosAptos,
        data: {
          aslib: { menu: { hide: false, text: 'Municípios Aptos' }},
          ascas: { title: 'Municípios Aptos' }
        }
      },
      {
        path: 'sarf-gerar-valor-mensal-municipio',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: GerarValorMensalDistribuir,
        data: {
          aslib: { menu: { hide: true, text: ' Gerar Valor Mensal a Distribuir' }},
          ascas: { title: 'Gerar Valor Mensal a Distribuir' }
        }
      },
      {
        path: 'sarf-consulta-valor-mensal-municipio',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: ConsultaValorMensalMunicipio,
        data: {
          aslib: { menu: { hide: false, text: ' Valor Mensal por Município' }},
          ascas: { title: 'Valor Mensal por Município' }
        }
      },
      {
        path: 'sarf-aprovacao-valor-mensal',
        canLoad: [AslibAuthGuard],
        canActivate: [AslibAuthGuard],
        component: AprovacaoValorMensalComponent,
        data: {
          aslib: { menu: { hide: false, text: 'Aprovar Valor Mensal por Município' }},
          ascas: { title: 'Aprovar Valor Mensal por Município' }
        }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts